import { useState, useRef, useEffect } from 'react';
import { useChat } from '@services/ChatProvider';
import styles from './ChatSidebar.module.scss';

export const MessageInput = () => {
	const [input, setInput] = useState('');
	const { sendMessage } = useChat();
	const inputRef = useRef(null);

	// Focus input when component mounts
	useEffect(() => {
		inputRef.current?.focus();
	}, []);

	const handleSubmit = (e) => {
		e.preventDefault();

		const trimmedInput = input.trim();
		if (!trimmedInput) return;

		sendMessage(trimmedInput);
		setInput('');
	};

	const handleKeyDown = (e) => {
		if (e.key === 'Enter' && !e.shiftKey) {
			e.preventDefault();
			handleSubmit(e);
		}
	};

	return (
		<form onSubmit={handleSubmit} className={styles.messageInputForm}>
			<input
				ref={inputRef}
				type="text"
				className={styles.messageInput}
				placeholder="Ask a question..."
				value={input}
				onChange={(e) => setInput(e.target.value)}
				onKeyDown={handleKeyDown}
				aria-label="Type your message"
			/>
			<button type="submit" className={styles.sendButton} disabled={!input.trim()} aria-label="Send message" title="Send message">
				<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path
						d="M18 2L9 11M18 2L12 18L9 11M18 2L2 8L9 11"
						stroke="currentColor"
						strokeWidth="2"
						strokeLinecap="round"
						strokeLinejoin="round"
					/>
				</svg>
			</button>
		</form>
	);
};
